import * as React from "react";
import {
    AppState,
    createUserForm,
    createUserFormBindings,
    changeCreateUserModalStatusAction,
    validateEmail,
    createUserAction
} from "@store";
import { Dispatch, connect } from "react-redux";
import "./CreateUserComponent.css";
import { Fieldset } from "./Fieldset";
import * as cn from "classnames";

export interface CreateUserComponentProps {
    createUserFormData: typeof createUserForm.types.selectorResult;
    createUserFormEvents: typeof createUserForm.types.eventBindings;
    onChangeStatusCreateUserModal: (isOpen: boolean) => void;
    onCreateClient: () => void;
}

export interface CreateUserComponentState {}

class CreateUserComponent extends React.Component<CreateUserComponentProps, CreateUserComponentState> {
    render() {
        const {
            onChangeStatusCreateUserModal,
            onCreateClient,
            createUserFormData: form,
            createUserFormEvents: events
        } = this.props;

        const isValid: boolean = validateEmail(form.fields.email.value);

        return (
            <div className="createUser">
                <h3 className="createUser__title">Create User</h3>
                <div className="createUser__item-wrapper">
                    <Fieldset
                        className="custom-createUser-fieldset createUser__item"
                        label="Email"
                        errorMessage={form.fields.email}
                        isMandatory={true}
                    >
                        <input
                            type="text"
                            name=""
                            id=""
                            value={form.fields.email.value || ""}
                            {...events.fields.email}
                        />
                    </Fieldset>
                </div>
                <div className="createUser__controls-wrapper">
                    <button
                        className={cn("common-btn custom-createUser-control-btn", !isValid ? "disabled" : "")}
                        type="button"
                        onClick={() => onCreateClient()}
                        disabled={!isValid}
                    >
                        Create
                    </button>
                    <button
                        className="common-btn custom-createUser-control-btn"
                        type="button"
                        onClick={() => onChangeStatusCreateUserModal(false)}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        );
    }
}

export interface CreateUserProps {}

export const CreateUser = connect(
    (state: AppState, ownProps: CreateUserProps): Partial<CreateUserComponentProps> => {
        return {
            createUserFormData: createUserForm.selector(state.usersState.createUserForm)
        };
    },
    (dispatch: Dispatch, ownProps: CreateUserProps): Partial<CreateUserComponentProps> => ({
        createUserFormEvents: createUserFormBindings.bind(dispatch, undefined),
        onChangeStatusCreateUserModal: (isOpen: boolean) => {
            dispatch(changeCreateUserModalStatusAction({ isOpen: isOpen }));
        },
        onCreateClient() {
            dispatch(createUserAction({}));
        }
    })
)(CreateUserComponent);
